import React, { useEffect, useState, useContext, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, message } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { UserContext } from "../../context/UserContext";
import { images } from "../../assets";
import Modal from "../../components/Modal";
import LogoutForm from "../../components/Forms/LogoutForm";
import "../../style/home/header.scss"; 

export default function Headers() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);

  const [menuOpen, setMenuOpen] = useState(false);
  const logoutModalRef = useRef(null);

  const navItems = [
    { title: t("home"), url: "/" },
    { title: t("profile"), url: "/profile" },
    { title: t("subscriptions"), url: "/pricingTable" },
    { title: t("calendar"), url: "/calendar" },
    { title: t("businesswall"), url: "/businessWall" },
  ];

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    // Disable body scroll when the mobile menu is open
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => {
      // Cleanup effect on unmount
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    setUser(null);
    message.success(t("logoutMessage"));
    navigate("/");
    logoutModalRef.current?.handleCancel();
  };

  const showLogoutModal = () => {
    logoutModalRef.current?.showModal();
  };

  return (
    <header className="main-header">
      {/* Logout Confirmation Modal */}
      <Modal modalRef={logoutModalRef}>
        <LogoutForm
          handleCancel={() => logoutModalRef.current?.handleCancel()}
          handleLogout={handleLogout}
        />
      </Modal>

      {/* Logo */}
      <div className="header-logo" onClick={() => navigate("/")}>
        <img src={images.logo} alt="Edge Hub Logo" className="logo-img" />
      </div>

      {/* Desktop Navigation */}
      <nav className={`header-nav ${menuOpen ? "is-active" : ""}`}>
        <ul className="nav-list">
          {navItems.map((item, index) => (
            <li key={index} className="nav-item">
              <NavLink to={item.url} className="nav-link" onClick={handleCloseMenu}>
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Action Buttons */}
      <div className="header-actions">
        {user ? (
          <Button className="logout-btn" onClick={showLogoutModal}>
            {t("logout")}
          </Button>
        ) : (
          <Button className="logout-btn" onClick={() => navigate("/login")}>
            {t("login")}
          </Button>
        )}
      </div>

      {/* Mobile Menu Toggle */}
      <div className="menu-toggle" onClick={handleMenuToggle}>
        <MenuOutlined />
      </div>

      {/* Backdrop for Mobile Menu */}
      {menuOpen && <div className="backdrop" onClick={handleCloseMenu}></div>}
    </header>
  );
}